import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { GetMenuItemStyleClass, labelStyleClass } from "./PlayerMenuStyles";

export function MenuItem({
    icon,
    label,
    onClick,
    onSelect,
}: {
    icon: EGlyphicon;
    label: string;
    onClick: Function;
    onSelect: () => void;
}) {
    return (
        <Hyperlink
            whenClicked={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onSelect();
                onClick();
            }}
            classes={GetMenuItemStyleClass()}
        >
            <Glyphicon icon={icon} />
            <span className={labelStyleClass}>{label}</span>
        </Hyperlink>
    );
}
